<ng-container *ngFor="let field of card?.fields">
    <!-- <div *ngIf="checkBeneficiaryAddress(item); else OtherField"  class="bl-display--flex bl-margin-bottom--16 bl-margin-top--32">
      <h3 class="bl-font-size--22 bl-font-weight--900 bl-margin-bottom--8">
        Address (Beneficiary{{item.field.iterationId + 1}}) </h3>
    </div>
    <ng-template #OtherField>
      <app-field-review [fieldSummary]="item"></app-field-review>
    </ng-template> -->
</ng-container>
